import { ReactElement } from 'react';
import { GuidT } from '@/types/common';
import IcoWardrobeLike from '@/assets/svg/ico_like.svg?react';
import IcoWardrobeAccessories from '@/assets/svg/ico_wardrobe_accessories.svg?react';
import IcoWardrobeAll from '@/assets/svg/ico_wardrobe_all.svg?react';
import IcoFullOutfit from '@/assets/svg/ico_wardrobe_full_outfit.svg?react';
import IcoWardrobeLower from '@/assets/svg/ico_wardrobe_lower.svg?react';
import IcoWardrobeOuterwear from '@/assets/svg/ico_wardrobe_outerwear.svg?react';
import IcoWardrobeShoes from '@/assets/svg/ico_wardrobe_shoes.svg?react';
import IcoWardrobeUpper from '@/assets/svg/ico_wardrobe_upper.svg?react';

export type WardrobeCategoryT =
    | 'all'
    | 'favorites'
    | 'upper'
    | 'lower'
    | 'outerwear'
    | 'shoes'
    | 'accessories'
    | 'fullOutfit';

export interface WardrobeCategoryTabConfigIF {
    type: WardrobeCategoryT;
    group: 'clothing' | 'service';
    icon: ReactElement;
    label?: string;
    serverLabel?: string;
}

export interface WardrobeCategoryIF extends Pick<
    WardrobeCategoryTabConfigIF,
    'type' | 'group' | 'icon'
> {
    id: GuidT;
    label: string;
    categoryGuid?: GuidT;
}

export const WARDROBE_CATEGORY_TABS: WardrobeCategoryTabConfigIF[] = [
    {
        type: 'all',
        group: 'service',
        label: 'Все',
        icon: <IcoWardrobeAll />,
    },
    {
        type: 'favorites',
        group: 'service',
        label: 'Любимое',
        icon: <IcoWardrobeLike />,
    },
    {
        type: 'upper',
        group: 'clothing',
        serverLabel: 'Верх',
        icon: <IcoWardrobeUpper />,
    },
    {
        type: 'lower',
        group: 'clothing',
        serverLabel: 'Низ',
        icon: <IcoWardrobeLower />,
    },
    {
        type: 'outerwear',
        group: 'clothing',
        serverLabel: 'Верхняя одежда',
        icon: <IcoWardrobeOuterwear />,
    },
    {
        type: 'shoes',
        group: 'clothing',
        serverLabel: 'Обувь',
        icon: <IcoWardrobeShoes />,
    },
    {
        type: 'accessories',
        group: 'clothing',
        serverLabel: 'Аксессуары',
        icon: <IcoWardrobeAccessories />,
    },
    {
        type: 'fullOutfit',
        group: 'clothing',
        serverLabel: 'Полный образ',
        icon: <IcoFullOutfit />,
    },
];
